import React, { useState, useEffect } from 'react'
import { useParams,useNavigate } from 'react-router-dom';
import { TailSpin } from "react-loader-spinner";
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../../actions/auth';
import  { GetQuestionById }  from '../../controllers/GetQuestionById';
import  { GetCourseChild }  from '../../controllers/GetCourseChild';
import { Navbar } from '../ui/NavBar';
import transEs from '../../translate/es.json';
import transCat from '../../translate/cat.json';
import transDe from '../../translate/de.json';
import transEn from '../../translate/en.json';
import transFr from '../../translate/fr.json';
import transOt from '../../translate/ot.json';
import transPr from '../../translate/pr.json';
import {encode as base64_encode} from 'base-64';

// Home to display "Pregunta"
export const QuestionFail = () => {
    const dispatch = useDispatch();
    const history = useNavigate();
    const langTxt = localStorage.getItem('userLanguage') || 'es';
    let transTxt = transEs;
    if(langTxt === 'es'){
        transTxt = transEs;
    }
    else if(langTxt === 'cat'){
        transTxt = transCat;
    }
    else if(langTxt === 'de'){
        transTxt = transDe;
    }
    else if(langTxt === 'en'){
        transTxt = transEn;
    }
    else if(langTxt === 'fr'){
        transTxt = transFr;
    }
    else if(langTxt === 'pr'){
        transTxt = transPr;
    }
    else{
        transTxt = transOt;
    }

    const [questionDes, setQuestionDes] = useState("");
    const [nameUnit, setNameUnit] = useState("");
    const { fatherId } = useParams();
    const { unitId } = useParams();
    const { questionId } = useParams();
    const cursoId = localStorage.getItem('courseId');
    const cursoColor = localStorage.getItem('courseColor');
    let listUnit = [];
    let user = useSelector( state => state.auth );
    const token = useSelector((state) => state.ui.token);
    if(!user?.id){
        if(sessionStorage.getItem('userSelect') && token){
            user = JSON.parse(sessionStorage.getItem('userSelect'));
        }
        else{
            dispatch(logout(token));
            history( '/auth/', {
            replace: true
            });
        }
    }
    const [cursoNombre, setCursoNombre] = useState('');
    const [imgBackType, setImgBackType] = useState(false);
    const [imgBack, setImgBack] = useState('');

    let ran = false;
    useEffect(() => {
        if (ran) return;
            setImgBackType(JSON.parse(window.localStorage.getItem('edufami_feedback_incorrect')).image_type)
            setImgBack(JSON.parse(window.localStorage.getItem('edufami_feedback_incorrect')).image_value)
            GetQuestionById(questionId, user.languaje, token, user.id)
            .then((e)=>{
                setQuestionDes(e[0].feedback_error)
            })
            .catch((e)=>{
                console.error(e);
                //dispatch(logout(token));
            });
            GetCourseChild(cursoId, user.languaje, token, user.id, fatherId)
            .then((e)=>{

                let found = e.find(element => element.id ===  parseInt(unitId));
                setNameUnit(found.text_value)
            })
            .catch((e)=>{
                console.error(e);
                //dispatch(logout(token));
            });
            // let couseL = JSON.parse(window.sessionStorage.getItem(`listCourse${cursoId}`))
            // if(couseL){
            //     setCursoNombre(couseL.name)
            // }
            setCursoNombre(window.localStorage.getItem(`courseName`))
            
        return () => (ran = true);
    }, [])

    const handlerClick = () => {
        history( `/question/${fatherId}/${unitId}/${questionId}`, {
            replace: true
        });
    };

    let img_wrong = `${process.env.REACT_APP_PRD_URL}/assets/answ_wr.png`;
    const disCourse = ()=>{

                return (<>
                    <div className="cont-fail"><img src={img_wrong} alt={nameUnit} className="wrong-answer" /></div>

                    <div className="question-tip" style={{whiteSpace: 'pre-line'}}>{questionDes}</div>

                    <div className="course-enter-q-a">
                        <button id="btnIngresar" tabIndex="0" className="btn m-1 btn-block btn-wfp-main wfp--btn wfp--btn--primary" onClick={handlerClick} style={{borderColor:  cursoColor,backgroundColor: cursoColor,color:  "#ffffff",}}>{transTxt.btn.volver_int.txt}</button>
                    </div>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    </>);

    }
    
    return (
        <div className="fund-main-unit">
            {
                    imgBackType && (imgBackType==="svg")
                    ?
                    <img className="fund-start-b-img" src = {`data:image/svg+xml;base64,${base64_encode(imgBack)}`} alt="Back Ground"/>
                    :(imgBackType!==null)?
                    <img className="fund-start-b-img" src = {`data:image/${imgBackType}+xml;base64,${btoa(imgBack)}`} alt="Back Ground"/>
                    :
                    null
                } 
            <Navbar title={cursoNombre}/>
            
            <div className="fund-fail-question">
            <div className="text-title"
            style={{
                backgroundColor: cursoColor,
                color:  "#ffffff",
            }}
            >{nameUnit && nameUnit}</div>
                <div className="content-questions" >
 
                <div className="container-question">
                {!listUnit && <div className="loader-page"><TailSpin
                    color="#00BFFF"
                    height={200}
                    width={200}
                />
                </div>}
                    { listUnit && disCourse() }
                </div>
                
                </div>
                
            </div>
        </div>
    )
}

